import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../theme/hooks/useFeatureTheme';

export default function EmptyState({
  icon,
  title,
  description,
  action,
  sx = {},
}) {
  const { semantic, typography } = useFeatureTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        px: 3,
        py: 6,
        color: semantic.text.secondary,
        ...sx,
      }}
    >
      {icon ? <Box sx={{ color: semantic.text.muted, fontSize: 40 }}>{icon}</Box> : null}
      {title ? (
        <Typography
          sx={{
            fontSize: typography.fontSizeLg,
            fontWeight: typography.fontWeightSemibold,
            color: semantic.text.primary,
          }}
        >
          {title}
        </Typography>
      ) : null}
      {description ? (
        <Typography sx={{ fontSize: typography.fontSizeMd, maxWidth: 360 }}>
          {description}
        </Typography>
      ) : null}
      {action ? <Box sx={{ mt: 1 }}>{action}</Box> : null}
    </Box>
  );
}
